<div class="top-container">
  <span class="name label-large"> Walkthrough </span>
  <img
    class="desktop-img d-none d-lg-block"
    alt="Walkthrough example desktop"
    src="/assets/new-ui/img/walkthrough_desktop.svg"
  />
  <img
    class="mobile-img d-lg-none"
    alt="Walkthrough example mobile"
    src="/assets/new-ui/img/walkthrough_mobile.svg"
  />
</div>
<div class="bottom-container">
  <span class="label-large"> Extra uitleg over de app nodig? </span>
</div>
